export const NAV_WIDTH_EXPANDED = 200;
export const NAV_WIDTH_COLLAPSED = 64;
export const STORAGE_KEY = 'renter_nav_expanded';
